module.exports = __webpack_public_path__ + "media/images/swifticons/switchers-9dc9d27044ba3dc8d8e4d35d43df0cdb.svg";